import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Project from './views/Project.vue'
import Report from './views/Report.vue'
import Login from './views/Login.vue'
import CreateAccount from './views/CreateAccount.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import Account from './views/Account.vue'
import DataDive from './views/DataDive.vue'
import Investigate from './views/Investigate.vue'
import Maintenance from './views/Maintenance.vue'
import KeywordDomainAnalysis from './views/KeywordDomainAnalysis.vue'
import Alerts from './views/Alerts.vue'
import Admin from './views/Admin.vue'
import Users from './views/Users.vue'
import ConfirmEmail from './views/ConfirmEmail.vue'
import NotFound from './views/NotFound.vue'
import ResetPassword from './views/ResetPassword.vue'
import Subscriptions from './views/Subscriptions.vue'
import ReportBuilder from './views/ReportBuilder.vue'
import Reports from './views/Reports.vue'
import Insights from './views/Insights.vue'
import { TokenService } from './services/storage.service'

const DEFAULT_TITLE = 'RankCaddy.io';

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title: "Not Found"
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
        title: "Login"
      }
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: Maintenance,
      meta: {
        public: true,
        title: "Maintenance"
      }
    },
    {
      path: '/create-account',
      name: 'create-account',
      component: CreateAccount,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
        title: "Create Account"
      }
    },
    {
      path: '/create-account/:couponCode',
      name: 'create-account2',
      component: CreateAccount,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
        title: "Create Account"
      }
    },
    {
      path: '/create-account/:inviteId/:inviteAuth',
      name: 'create-account3',
      component: CreateAccount,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
        title: "Create Account"
      }
    },
    {
      path: '/confirm-email/*',
      name: 'confirm-email',
      component: ConfirmEmail,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: false,
        title: "Confirm Email"
      }
    },
    {
      path: '/reset-password/:code',
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
        title: "Rest Password"
      }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
        title: "Forgot Password"
      }
    },
    {
      path: '/pricing',
      name: 'subscriptions-public',
      component: Subscriptions,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: false,
        title: "Pricing",
        noTrack: true
      }
    },
    {
      path: '/account/*',
      name: 'account',
      component: Account,
      meta: {
        title: "Account",
      }
    },
    {
      path: '/data-dive',
      name: 'dashboard-data-dive',
      component: Dashboard,
      meta: {
        title: "Data Dive",
      }
    },
    {
      path: '/data-dive/:projectId/:type',
      name: 'data-dive-project',
      component: DataDive,
      meta: {
        title: "Data Dive",
      }
    },
    {
      path: '/content-and-keywords/search/:keyword/:country/:language',
      name: 'content-and-keywords-run',
      component: KeywordDomainAnalysis,
      meta: {
        nameAsKey: true,
        title: "Content & Keywords"
      }
    },
    {
      path: '/content-and-keywords/:type/:key/:tabId',
      name: 'content-and-keywords',
      component: KeywordDomainAnalysis,
      meta: {
        nameAsKey: true,
        title: "Content & Keywords"
      }
    },
    {
      path: '/content-and-keywords/:type/:key/:tabId/:subTabId',
      name: 'content-and-keywords-subtab',
      component: KeywordDomainAnalysis,
      meta: {
        nameAsKey: true,
        title: "Content & Keywords"
      }
    },
    {
      path: '/content-and-keywords/stats/:key',
      name: 'content-and-keywords-stats',
      component: KeywordDomainAnalysis,
      meta: {
        nameAsKey: true,
        title: "Content & Keywords"
      }
    },
    {
      path: '/content-and-keywords',
      name: 'content-and-keyword-search',
      component: KeywordDomainAnalysis,
      meta: {
        title: "Content & Keywords"
      }
    },
    {
      path: '/website-analysis/search/:keyword/:country/:language',
      name: 'website-analysis-run',
      component: KeywordDomainAnalysis,
      meta: {
        nameAsKey: true,
        title: "Content & Keywords"
      }
    },
    {
      path: '/website-analysis/:type/:key/:tabId',
      name: 'website-analysis',
      component: KeywordDomainAnalysis,
      meta: {
        nameAsKey: true,
        title: "Content & Keywords"
      }
    },
    {
      path: '/website-analysis/:type/:key/:tabId/:_id',
      name: 'website-analysis2',
      component: KeywordDomainAnalysis,
      meta: {
        nameAsKey: true,
        title: "Content & Keywords"
      }
    },
    {
      path: '/website-analysis',
      name: 'website-analysis-search',
      component: KeywordDomainAnalysis,
      meta: {
        title: "Content & Keywords"
      }
    },
    {
      path: '/investigate',
      name: 'investigate',
      component: Investigate,
      meta: {
        title: "Investigate"
      }
    },
    {
      path: '/alerts/*',
      name: 'alerts',
      component: Alerts,
      meta: {
        title: "Alerts"
      }
    },
    {
      path: '/admin/*',
      name: 'admin',
      component: Admin,
      meta: {
        title: "Admin"
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        title: "Users"
      }
    },
    {
      path: '/report/:projectId',
      name: 'project-report',
      component: Report,
      meta: {
        headerClasses: { fade: true },
        footerClasses: { fade: true },
        title: "Project Report"
      }
    },
    {
      path: '/rank-tracking',
      name: 'dashboard-rank-tracking',
      component: Dashboard
    },
    {
      path: '/rank-tracking/:projectId',
      name: 'dashboard-rank-tracking-project',
      component: Project,
      meta: {
        title: "Project"
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports
    },
    {
      path: '/reports/:projectId',
      name: 'report-builder',
      component: ReportBuilder
    },
    {
      path: '/reports/:projectId/:reportId',
      name: 'report-builder2',
      component: ReportBuilder
    },
    {
      path: '/reports/:projectId/:reportId/generate',
      name: 'report-builder-generate',
      component: ReportBuilder
    },
    {
      path: '/:projectId/',
      name: 'NotFound-project',
      component: NotFound,
      meta: {
        title: "Not Found"
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    }
  ]
})
export default router;

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/login/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  next();
})

router.afterEach((to) => {
  if ( typeof gtag !== 'undefined' && !to.meta.noTrack ) {
    gtag('config', 'G-F9NT3JPYVH', {
      page_path: to.fullPath,
      app_name: DEFAULT_TITLE,
      send_page_view: true,
    });
  }
  Vue.nextTick(() => {
      document.title = to.meta.title ? ( DEFAULT_TITLE + ': ' + to.meta.title ) : DEFAULT_TITLE;
  });
});